<div class="webhooks-edit-component scroll-container fullpage">

  <div class="row">
    <div class="col">

      <!-- Webhook Form -->
      @if (webhook) {
        <div>
          @if (webhooksEditForm) {
            <form [formGroup]="webhooksEditForm.form"
              (ngSubmit)="saveWebhook(webhooksEditForm.model)"
              appPreventEnter>
              <formly-form [form]="webhooksEditForm.form"
                [fields]="webhooksEditForm.fields"
                [model]="webhooksEditForm.model"
                [options]="webhooksEditForm.options">
              </formly-form>
            </form>
          }
        </div>
      } @else {
        <div class="alert alert-warning" role="alert">
          @if (id === null) {
            <span i18n="@@components.webhooks.no_webhook_with_id">There is no webhook with the given id</span>
          } @else {
            <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
          }
        </div>
      }
      <!-- Webhook Form end -->

      <!-- No Results -->
      <!-- No Results end -->

    </div>
  </div>
</div>
